import { useNotify } from '../hooks/useNotify'

export interface TwBenchmarkApiError {
  type: string
  message?: string
  status?: number
}

export interface TwBenchmarkApiResponse<T> {
  data?: T
  error?: TwBenchmarkApiError
}

export interface TwBenchmarkApiResult<T> {
  isSuccess: boolean
  data?: T
  error?: TwBenchmarkApiError
}

const CALLER_HANDLED_ERROR_TYPES: ReadonlySet<string> = new Set(['DUPLICATE'])

/**
 * API レスポンスの成否を結果型へ変換し、失敗時はエラートーストを出す共通ハンドラ（401 と呼び出し側処理の種別は二重通知を避けて抑止）。
 */
export function handleApiResponse<T>(
  response: TwBenchmarkApiResponse<T> | Error | undefined | null
): TwBenchmarkApiResult<T> {
  const { handleApiNotify } = useNotify()

  const errorInfo = response instanceof Error ? undefined : response?.error

  if (errorInfo?.status === 401) {
    return { isSuccess: false }
  }

  if (errorInfo?.type) {
    if (!CALLER_HANDLED_ERROR_TYPES.has(errorInfo.type)) {
      handleApiNotify()
    }

    return {
      isSuccess: false,
      error: errorInfo
    }
  }

  if (response instanceof Error || !response || !response.data) {
    handleApiNotify()

    return { isSuccess: false }
  }

  return { isSuccess: true, data: response.data }
}
